import React from 'react'
import { Box, Text} from 'pcln-design-system'
import {
  PhoneSalesBannerContainer,
  PhoneLink,
  StyledResponsiveImg,
  MobilePhoneLinkWrapper
} from './PhoneSalesBannerStyledComponents'

interface Props {
  leftLabel?: string
  leftSubLabel?: string
  rightLabel?: string
  phoneNumber?: string
  iconBgColor?: string
  onPhoneNumberClick?: () => void
  imageUrl?: string
  isDesktop?: boolean
}

const PhoneSalesBanner: React.FC<Props> = ({
  leftLabel,
  leftSubLabel,
  rightLabel,
  phoneNumber,
  onPhoneNumberClick,
  imageUrl,
}: Props) => (
  <MobilePhoneLinkWrapper width={1}>
  <PhoneSalesBannerContainer
    width={1} pr={[2, 3]} boxShadowSize='sm'
  >
    <StyledResponsiveImg src={imageUrl} />
    <Box py={['2px', 3]} width={['calc(100% - 200px)', 'calc(72% - 50px)']}>
<     Text pl={2} bold fontSize={[0, 1]} pb={1}>
        {leftLabel}
      </Text>
        <Text fontSize={[0, 1]}>{leftSubLabel}</Text> 
    </Box>
          <Box py={[2, 3]} width={['150px', '28%']}>
        <Text textAlign={['right', 'center']} fontSize={[0, 1]} pb={1}>
          {rightLabel}
        </Text>
        <Text onClick={onPhoneNumberClick} bold textAlign={['right', 'center']} fontSize={[0, 1]}>
          <PhoneLink href={`tel:${phoneNumber}`}>{phoneNumber}</PhoneLink>
        </Text>
        </Box>
  </PhoneSalesBannerContainer>
  </MobilePhoneLinkWrapper>
)

PhoneSalesBanner.defaultProps = {
  leftLabel: 'Priceline Phone Deals',
  leftSubLabel: 'Book with an agent for great rates!',
  rightLabel: 'Call now!',
  phoneNumber: '800-089-9998',
  iconBgColor: 'promoPrimary.dark',
}

export default PhoneSalesBanner